var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-form-select',{staticStyle:{"width":"100%"},style:({color: _vm.$store.state.siteData.legColors[_vm.index], border: '1px solid gray'}),attrs:{"size":"sm","options":_vm.options},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }